export default __webpack_public_path__ + "static/media/tut5.560e7097.png";